export enum CommonTypeKeys {
    QUESTION_DATA_UPDATED = 'common/QUESTION_DATA_UPDATED',
    SCORE_UPDATE_NOTIFICATION = 'common/SCORE_UPDATE_NOTIFICATION',
    ANNOTATIONS_UPDATE_NOTIFICATION = 'common/ANNOTATIONS_UPDATE_NOTIFICATION',
    AUDIT_TRAIL_NOTIFICATION = 'common/AUDIT_TRAIL_NOTIFICATION',
}

export interface QuestionDataUpdated {
    type: CommonTypeKeys.QUESTION_DATA_UPDATED;
    questionIds: number[];
    userIds: number[];
}

export interface AnnotationsPushUpdate {
    type: CommonTypeKeys.ANNOTATIONS_UPDATE_NOTIFICATION;
}

export interface PushUpdate{
    type: CommonTypeKeys.SCORE_UPDATE_NOTIFICATION;
    payload: {
        partyId: number;
        questionId?: number;
    };
}

export interface AuditTrailPushUpdate {
    type: CommonTypeKeys.AUDIT_TRAIL_NOTIFICATION;
}

export const questionDataUpdated = (questionIds: number[], userIds: number[]): QuestionDataUpdated => ({
    questionIds,
    userIds,
    type: CommonTypeKeys.QUESTION_DATA_UPDATED,
});

export const pushScoreUpdateNotification = (partyId: number, questionId?: number): PushUpdate => ({
    type: CommonTypeKeys.SCORE_UPDATE_NOTIFICATION,
    payload: {
        partyId,
        questionId,
    },
});

export const pushAuditTrailUpdateNotification = (): AuditTrailPushUpdate => ({
    type: CommonTypeKeys.AUDIT_TRAIL_NOTIFICATION,
});

export const annotationsUpdate = (): AnnotationsPushUpdate => ({
    type: CommonTypeKeys.ANNOTATIONS_UPDATE_NOTIFICATION,
});

export type CommonActionTypes = | QuestionDataUpdated | PushUpdate;
